<template>
<div class="swaychat-conversation" ref="conversation" tabindex="-1" @scroll="checkVisible" :style="{
    maxHeight: maxHeight + 'px'
    }">

  <component v-for="(item,index) in cache" :ref="'cache'+index" :is="item.template+'Cache'" :operator="item.operator" :from="item.from" :read="item.read" :meta="item.meta" :msgLength="item.msgLength" :media="item.media" :tail="item.tail" :created_at="item.created_at">
  </component>

  <component v-for="(item,index) in getMessages" :ref="'msg'+index" :is="item.template" :operator="item.operator" :message="item.message" :meta="item.meta" :tail="item.tail" :from="item.from" :media="item.media" :created_at="item.created_at" :subtype="item.subtype"
    :msgKey="item.msgKey" :read="item.read">
  </component>

  <!-- <div class="swaychat-bubble-wrapper swaychat-operator" v-if="isOperatorTyping">
    <div class="swaychat-typing swaychat-bubble">
      <div class="swaychat-spinner">
        <span class="swaychat-bounce1"></span>
        <span class="swaychat-bounce2"></span>
        <span class="swaychat-bounce3"></span>
      </div>
    </div>
    <span class="swaychat-tail"></span>
  </div> -->

</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import firebaseApp from '../utils/firebase'

import Message from './cards/Message.vue'
import MessageCache from './cards/MessageCache.vue'
import DateHeader from './cards/DateHeader.vue'
import DateHeaderCache from './cards/DateHeaderCache.vue'
import Attachment from './cards/Attachment.vue'
import AttachmentCache from './cards/AttachmentCache.vue'

export default {
  components: {
    Message,
    MessageCache,
    DateHeader,
    DateHeaderCache,
    Attachment,
    AttachmentCache,
  },
  created() {
    window.addEventListener('resize', this.setMaxHeight)

    if (!this.getMessages.length)
      this.cache = this.getCache

    this.setMaxHeight()

  },
  mounted() {
    this.scrollDown()
    this.checkVisible()
  },
  destroyed() {
    window.removeEventListener('resize', this.setMaxHeight)
  },
  data() {
    return {
      maxHeight: 0,
      cache: [],
      firstLoad: true,
      scrollTimer: null
    }
  },
  computed: {
    dropAllowed() {
      return 'FileReader' in window && !this.getSettings.no_upload
    },
    ...mapGetters([
      'getMessages',
      'isMinimize',
      'getCache',
      'getSettings',
      'bindSID',
      'doScroll',
      'isSwayChatPopout'
      // 'isOperatorTyping',
    ])
  },
  watch: {
    bindSID(newSID) {
      if (newSID) {
        let items = this.getMessages
        for (let i in items) {
          if (['Message', 'Attachment'].indexOf(items[i].template) >= 0 &&
            !items[i].delivered
          )
            this.$store.dispatch('markAsDelivered', items[i].msgKey)
        }
      }
    },
    doScroll() {
      this.$refs.conversation.scrollTop = this.$refs.conversation.scrollHeight
    },
    getMessages(n, o) {

      this.$store.dispatch('storeCache', n)

      if (n.length)
        this.cache = []

      if (this.firstLoad ||
        (n.length != o.length &&
          n[n.length - 1].from &&
          n[n.length - 1].from == this.$store.state.uid)
      ) {
        this.firstLoad = false
        this.scrollDown()
        this.checkVisible()
      }
    },
    isMinimize(v) {
      if (!v)
        this.scrollDown()
    }
  },
  methods: {
    scrollDown() {


      if (this.isMinimize && !this.isSwayChatPopout)
        return

      let msgs = this.getMessages.length ? this.getMessages : this.cache

      if (msgs.length)
        this.$nextTick(() => {

          let top = 0
          let target = null

          for (let i in this.$refs) {

            if (i != 'conversation' &&
              this.$refs[i][0] &&
              this.$refs[i][0].$el &&
              (
                (this.$refs[i][0].from != this.$store.state.uid && this.$refs[i][0].read) ||
                (this.$refs[i][0].from == this.$store.state.uid)
              )
            ) {
              target = this.$refs[i][0].$el
            }

          }

          if (target)
            this.scrollTimer = this.$scrollTo(target, this.firstLoad ? 1000 : 500, {
              container: this.$refs.conversation,
              easing: 'ease',
              offset: this.firstLoad ? -32 : -38
            })
          //this.$refs.conversation.scrollTop = top

        })

    },
    checkVisible() {

      if (!this.isMinimize)
      for (let i in this.$refs) {

        if (i != 'conversation' &&
          this.$refs[i][0] &&
          this.$refs[i][0].$el &&
          !this.$refs[i][0].read &&
          this.$refs[i][0].from != this.$store.state.uid &&
          this.$refs[i][0].msgKey &&
          this.isVisible(this.$refs[i][0].$el)
        ) {
          this.$store.dispatch('markAsRead', this.$refs[i][0].msgKey)
        }

      }


    },
    setMaxHeight() {
      this.maxHeight = document.documentElement.clientHeight
      if (!window.isSwayChatPopout) this.maxHeight -= 228
      if (this.maxHeight > 267) this.maxHeight = 267
    },
    isVisible(el) {

      if (typeof el.getBoundingClientRect !== 'function')
        return true

      let rect = el.getBoundingClientRect()
      let parentRect = el.parentNode.getBoundingClientRect()
      return (rect.bottom <= parentRect.bottom)

    }
  }
}
</script>
